import React, { useState } from 'react';
import { collaborationTypes } from '../data/mockData';
import { Send, Mail, MessageSquare, Upload, Users } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    location: '',
    subject: '',
    message: '',
    inquiryType: 'general',
    file: null
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // This will be connected to backend later
    console.log('Contact form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      file: e.target.files[0]
    }));
  };

  return (
    <div className="min-h-screen bg-[#1a1c1b] pt-20">
      {/* Hero */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="/images/kellies-castle.jpg"
            alt="Contact"
            className="w-full h-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1a1c1b] via-[#1a1c1b]/90 to-[#1a1c1b]"></div>
        </div>
        
        <div className="container-custom relative z-10">
          <h1 className="heading-1 text-[#dc2626] mb-6 max-w-3xl">
            Get in Touch
          </h1>
          <p className="body-large text-white/90 max-w-3xl">
            Built on shared knowledge, respectful dialogue, and meaningful collaboration.
          </p>
        </div>
      </section>

      {/* Contact Options */}
      <section className="space-section bg-[#0f0f10]">
        <div className="container-custom">
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="bg-[#1a1c1b] p-8 rounded-lg border border-[#3a2222] text-center">
                <Mail className="text-[#dc2626] mx-auto mb-4" size={48} />
                <h3 className="heading-4 text-white mb-3">Email</h3>
                <a 
                  href="mailto:contact@darktourism-malaysia.com" 
                  className="text-[#dc2626] hover:text-[#dc2626]/80 transition-colors"
                >
                  contact@darktourism-malaysia.com
                </a>
              </div>

              <div className="bg-[#1a1c1b] p-8 rounded-lg border border-[#3a2222] text-center">
                <MessageSquare className="text-[#dc2626] mx-auto mb-4" size={48} />
                <h3 className="heading-4 text-white mb-3">WhatsApp</h3>
                <a 
                  href="https://wa.me/60177975779" 
                  className="text-[#dc2626] hover:text-[#dc2626]/80 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +60 17-797 5779
                </a>
              </div>

              <div className="bg-[#1a1c1b] p-8 rounded-lg border border-[#3a2222] text-center">
                <svg className="text-[#dc2626] mx-auto mb-4" width="48" height="48" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                <h3 className="heading-4 text-white mb-3">Instagram</h3>
                <a 
                  href="https://instagram.com/darktourism.malaysia" 
                  className="text-[#dc2626] hover:text-[#dc2626]/80 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @darktourism.malaysia
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="space-section bg-[#1a1c1b]">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 text-[#dc2626] mb-8">Send Us a Message</h2>

            <div className="bg-[#302f2c] p-8 rounded-lg border-l-4 border-[#dc2626] mb-12">
              <h3 className="heading-4 text-white mb-4">We Welcome Messages About:</h3>
              <ul className="space-y-2 body-small text-white/70">
                <li>• Suggesting forgotten or overlooked sites</li>
                <li>• Sharing information or historical details</li>
                <li>• Asking questions about dark tourism in Malaysia</li>
                <li>• Providing feedback or corrections</li>
                <li>• Media inquiries and speaking opportunities</li>
                <li>• Collaboration proposals</li>
              </ul>
            </div>

            {submitted && (
              <div className="bg-[#dc2626] text-white p-6 rounded-lg mb-8 flex items-center gap-4">
                <Send size={24} />
                <div>
                  <p className="font-semibold">Message sent successfully!</p>
                  <p className="text-sm">We'll get back to you within 2-3 business days.</p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Inquiry Type */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  Inquiry Type <span className="text-[#dc2626]">*</span>
                </label>
                <select
                  name="inquiryType"
                  value={formData.inquiryType}
                  onChange={handleChange}
                  required
                  className="w-full bg-[#302f2c] border border-[#3a2222] rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#dc2626] transition-colors"
                >
                  <option value="general">General Inquiry</option>
                  <option value="site">Site Suggestion</option>
                  <option value="media">Media / Interview Request</option>
                  <option value="collaboration">Collaboration Proposal</option>
                  <option value="feedback">Feedback / Correction</option>
                  <option value="other">Other</option>
                </select>
              </div>

              {/* Name */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  Your Name <span className="text-[#dc2626]">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full bg-[#302f2c] border border-[#3a2222] rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#dc2626] transition-colors"
                  placeholder="Enter your full name"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  Email Address <span className="text-[#dc2626]">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-[#302f2c] border border-[#3a2222] rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#dc2626] transition-colors"
                  placeholder="your.email@example.com"
                />
              </div>

              {/* Location */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  Location (Optional)
                </label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  className="w-full bg-[#302f2c] border border-[#3a2222] rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#dc2626] transition-colors"
                  placeholder="City, State, Country"
                />
              </div>

              {/* Subject */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  Subject <span className="text-[#dc2626]">*</span>
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full bg-[#302f2c] border border-[#3a2222] rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#dc2626] transition-colors"
                  placeholder="Brief subject line"
                />
              </div>

              {/* Message */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  Message <span className="text-[#dc2626]">*</span>
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="8"
                  className="w-full bg-[#302f2c] border border-[#3a2222] rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#dc2626] transition-colors resize-y"
                  placeholder="Tell us more about your inquiry..."
                />
              </div>

              {/* File Upload */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  Attach File (Optional)
                </label>
                <div className="border-2 border-dashed border-[#3a2222] rounded-lg p-6 text-center hover:border-[#dc2626] transition-colors">
                  <Upload className="mx-auto text-[#dc2626] mb-3" size={40} />
                  <p className="text-white text-sm mb-2">Click to upload or drag and drop</p>
                  <p className="text-[#888680] text-xs mb-3">Documents, images up to 10MB</p>
                  <input
                    type="file"
                    onChange={handleFileChange}
                    accept="image/*,.pdf,.doc,.docx"
                    className="hidden"
                    id="contact-file-upload"
                  />
                  <label htmlFor="contact-file-upload" className="btn-secondary text-sm cursor-pointer inline-block">
                    Choose File
                  </label>
                  {formData.file && (
                    <p className="text-[#dc2626] mt-3 text-sm">Selected: {formData.file.name}</p>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" className="btn-primary w-full text-lg">
                <Send className="mr-2" size={20} />
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Collaborations */}
      <section className="space-section bg-[#0f0f10]">
        <div className="container-custom">
          <div className="max-w-5xl mx-auto">
            <div className="flex items-center gap-4 mb-12">
              <Users className="text-[#dc2626]" size={48} />
              <h2 className="heading-2 text-[#dc2626]">Collaborations</h2>
            </div>

            <p className="body-medium text-white/80 mb-12 max-w-3xl">
              We are always open to meaningful partnerships focused on historical awareness, 
              respectful storytelling, and heritage preservation. We welcome collaboration with:
            </p>

            <div className="grid md:grid-cols-2 gap-8">
              {collaborationTypes.map((collab, index) => (
                <div 
                  key={index}
                  className="bg-[#1a1c1b] p-8 rounded-lg border border-[#3a2222] hover:border-[#dc2626]/50 transition-colors"
                >
                  <h3 className="heading-4 text-[#dc2626] mb-4">{collab.title}</h3>
                  <p className="body-small text-white/70">{collab.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-12 text-center">
              <p className="body-large text-white/90 mb-6">
                Interested in partnering with us?
              </p>
              <p className="body-medium text-white/70">
                Please use the contact form above and select "Collaboration Proposal" as your inquiry type.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
